
import Vue from "vue";
import msDataProvider from "../../services/msDataProvider";
import XCardBasedForm from "../../components/XCardBasedForm.vue";
import uiService from "../../services/uiService";
import errorService from "../../services/errorService";
import { mdiArrowLeft } from "@mdi/js";

export default Vue.extend({
  components: {
    XCardBasedForm,
  },
  data() {
    return {
      errorService,
      mdiArrowLeft,
      data: {},
      binding: {},
      buttonCondition() {
        return (
            this.binding.enrollmentEnrollmentStatus &&
            !this.binding.enrollmentEnrollmentStatus.sent &&
            this.binding.enrollmentEnrollmentStatus.enrollment_request &&
            this.binding.enrollmentEnrollmentStatus.enrollment_request.device_id
        );
      },
    };
  },
  computed: {
    prepareInfo() {
      return {
        email: this.binding.authenAuthenInfo &&
            this.binding.authenAuthenInfo.user_info &&
            this.binding.authenAuthenInfo.user_info.email || '',
        device_name: this.binding.enrollmentEnrollmentStatus &&
            this.binding.enrollmentEnrollmentStatus.enrollment_request &&
            this.binding.enrollmentEnrollmentStatus.enrollment_request.device_name || '',
        device_id: this.binding.enrollmentEnrollmentStatus &&
            this.binding.enrollmentEnrollmentStatus.enrollment_request &&
            this.binding.enrollmentEnrollmentStatus.enrollment_request.device_id || ''
      }
    }
  },
  methods: {
    async submit(callback) {
      try {
        await msDataProvider.executeCommand(
            "enrollmentSendEnrollmentRequest",
            this.data.message
        );
        this.$router.push("wait");
        callback();
      } catch (e) {
        const {err, showNotiSystem} = this.errorService.normalize(e)
        if (showNotiSystem) {
          this.$emit('error', err)
          callback()
        } else {
          callback(err, true)
        }
      }
    },
    async logout() {
      if (
          await uiService.executeCommand(
              "confirmShow",
              {
                message: this.$t("LAYOUT.DO_YOU_REALLY_WANT_TO_LOGOUT_THIS_APP"),
                title: this.$t("LAYOUT.LOGOUT"),
                cancel: this.$t("LAYOUT.CANCEL"),
                ok: this.$t("LAYOUT.LOGOUT"),
                iconOk: 'icon-logout-white24'
              },
              true
          )
      ) {
        uiService.executeCommand("try", {
          async func() {
            await msDataProvider.executeCommand("authenLogout", {});
            this.$router.push("/prepare").catch((e) => e);
          },
          self: this,
        });
        sessionStorage.removeItem('userId');
      }
    },
  },
  async created() {
    msDataProvider.bindDataMany(
        ["enrollmentEnrollmentStatus", "authenAuthenInfo"],
        this.binding,
        this,
        null,
        this
    );
  },
  beforeRouteLeave(to, from, next) {
    msDataProvider.unregisterView(this);
    next();
  },
});
